export const ENV = 'development';

export const BG_TEXT = 'LOCAL';
export const API_URL = 'https://api.gravy.work/api';
export const API = 'https://api.gravy.work/api';

//export const API_URL = 'http://localhost:3000/api';

//export const API = 'http://localhost:3000/api';



// WEBPACK FOOTER //
// ./src/settings/development.js